import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { API, http } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const authHeader = useCallback(() => ({}), []);

  useEffect(() => {
    localStorage.removeItem("id_token");
    http.get(`${API}/auth/me`)
      .then(({ data }) => setUser(data.user))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const register = useCallback(async (payload) => {
    const { data } = await http.post(`${API}/auth/register`, payload);
    setUser(data.user);
    return data.user;
  }, []);

  const login = useCallback(async (payload) => {
    const { data } = await http.post(`${API}/auth/login`, payload);
    setUser(data.user);
    return data.user;
  }, []);

  const switchRole = useCallback(async (role) => {
    const { data } = await http.post(`${API}/auth/switch-role`, { role });
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try { await http.post(`${API}/auth/logout`); } finally { setUser(null); }
  }, []);

  const value = useMemo(
    () => ({ token: user ? "cookie" : "", user, loading, register, login, logout, switchRole, authHeader }),
    [user, loading, register, login, logout, switchRole, authHeader],
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
